import logoSvgPaths from '../../../public/assets/logo-svg-paths';

interface ReneoLogoProps {
    size?: 'sm' | 'md' | 'lg';
    variant?: 'full' | 'icon' | 'text';
    className?: string;
}

export function ReneoLogo({ size = 'md', variant = 'full', className = '' }: ReneoLogoProps) {
    const iconSizeClasses = {
        sm: 'h-6 w-6',
        md: 'h-8 w-8',
        lg: 'h-12 w-12',
    };

    if (variant === 'icon') {
        return (
            <div className={`${iconSizeClasses[size]} ${className}`}>
                <svg className="block size-full" fill="none" preserveAspectRatio="xMidYMid meet" viewBox="0 0 427 86">
                    <g id="Reneo_Icon">
                        <path d={logoSvgPaths.p328a1800} fill="url(#paint0_linear_reneo)" />
                    </g>
                    <defs>
                        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_reneo" x1="0.00732642" x2="426.824" y1="42.7917" y2="42.7917">
                            <stop offset="0.00018359" stopColor="#64D9CC" />
                            <stop offset="0.0749463" stopColor="#61DAC2" />
                            <stop offset="0.4986" stopColor="#53DE91" />
                            <stop offset="0.8201" stopColor="#49E072" />
                            <stop offset="0.9996" stopColor="#46E166" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        );
    }

    if (variant === 'text') {
        return (
            <div className={`${className}`}>
                <span className="reneo-gradient-text font-bold text-2xl tracking-tight">reneo</span>
            </div>
        );
    }

    return (
        <div className={`flex items-center space-x-3 ${className}`}>
            <div className={iconSizeClasses[size]}>
                <svg className="block size-full" fill="none" preserveAspectRatio="xMidYMid meet" viewBox="0 0 427 86">
                    <g id="Reneo_Full">
                        <path d={logoSvgPaths.p328a1800} fill="url(#paint0_linear_reneo_full)" />
                    </g>
                    <defs>
                        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_reneo_full" x1="0.00732642" x2="426.824" y1="42.7917" y2="42.7917">
                            <stop offset="0.00018359" stopColor="#64D9CC" />
                            <stop offset="0.0749463" stopColor="#61DAC2" />
                            <stop offset="0.4986" stopColor="#53DE91" />
                            <stop offset="0.8201" stopColor="#49E072" />
                            <stop offset="0.9996" stopColor="#46E166" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="flex flex-col">
                <span className="reneo-gradient-text font-bold text-lg leading-none tracking-tight">reneo</span>
                <span className="text-muted-foreground text-xs uppercase tracking-wide">Property Management</span>
            </div>
        </div>
    );
}
